import { useStats } from 'react-instantsearch';

/* eslint-disable-next-line */
export interface SearchStatsProps {}

export function SearchStats(props: SearchStatsProps) {
    const { nbHits } = useStats();
    if (nbHits === 0) return null;

    return (
        <div className="text-white h3">
            {nbHits} {nbHits === 1 ? 'Result' : 'Results'}
        </div>
    );
}

export default SearchStats;
